import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sIsBusy: false,
    sIsLogin: false,
    sUsuario: {}
  },
  mutations: {
    setIsBusy (state, payload) {
      state.sIsBusy = payload
    },
    setIsLogin (state, payload) {
      state.sIsLogin = payload
    },
    setUser (state, payload) {
      state.sUsuario = payload
    }
  },
  actions: {
    setIsBusy({state, commit}, valor) {
      commit('setIsBusy', valor)
    },
    setIsLogin({state, commit}, valor) {
      commit('setIsLogin', valor)
    },
    setUser({state, commit}, user) {
      commit('setUser', user)
    }
  },
  modules: {
  }
})
